import { z } from 'zod'

export const ADMINAUDITCANARYPOST_CONTRACT_VERSION = '1.0.0' as const
export const adminAuditCanaryPostResponseSchema = z.unknown()
export type AdminAuditCanaryPostResponse = z.infer<typeof adminAuditCanaryPostResponseSchema>
